const SportsModule = () => import(/* webpackChunkName: "sports-module" */ './views/Module.vue'); 
const Sports = () => import(/* webpackChunkName: "sports" */ './views/Sports.vue');
const SportEventDetail = () => import(/* webpackChunkName: "sport-event-detail" */ './views/SportEventDetail.vue');
const SportsBook = () => import(/* webpackChunkName: "sport-book" */ './views/SportsBook.vue');

const SportsRoutes =   {
    path: '/',
    component: SportsModule,
    children: [
      {
        path: 'sports/:type/:id',
        name: 'sports',
        component: Sports
      },
      {
        path: 'sports-event-detail/:event_id/:is_pool?',
        name: 'SportEventDetail',
        component: SportEventDetail
      },
      {
        path: 'sports-book',
        name: 'sports-book',
        component: SportsBook
      }

    ],
  }

export default SportsRoutes;